import NotificationsCenterAll from './NotificationsCenterAll'

export default NotificationsCenterAll
// eslint-disable-next-line import/export
export * from './NotificationsCenterAll'
